import type { PImage } from '../../engine/aliases'
import { distanceUtil } from '../../lib/distanceUtil-sidecar'
import { l } from '../../lib/imports'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { clickEater } from '../../uiParts/clickEater-sidecar'
import type { IStevieText2 } from '../../uiParts/stevieTexts2'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { chessCamera } from './chessCamera-sidecar'
import { chessGameManager } from './chessGameManager-sidecar'
import { chessGameMode_game } from './chessGameMode_game-sidecar'
import { chessLayers } from './chessLayers-sidecar'
import type { IChessPiece } from './chessPieces'
import { chessPieces } from './chessPieces-sidecar'
import { chessTilemap } from './chessTilemap-sidecar'
import { EChessCursorPickCommand } from './messages/chessMessageCursorPick'
import { chessMessageCursorPick } from './messages/chessMessageCursorPick-sidecar'
import { chessMessagePieceMoveRequest } from './messages/chessMessagePieceMoveRequest-sidecar'
import { chessSounds } from './sound/chessSounds-sidecar'
import { chessFonts } from './ui/chessFonts-sidecar'

export interface IChessPicker {
  imageCursor: PImage
  imageSelected: PImage
  imageWillSelect: PImage
  imageHoveredTile: PImage
  imageShadow: PImage
  selectedPiece: IChessPiece | null
  hoveredPiece: IChessPiece | null
  textPiece: IStevieText2
  lastClosestPiece: IChessPiece | null
}

let _obj: IChessPicker | null = null
export function get() {
  if (!_obj) {
    _obj = create()
  }
  return _obj
}

function create(): IChessPicker {
  let imageCursor = spritesUtil.createImage(
    chessLayers.getLayers().abovePieces,
    sprites.chessCircle[0],
  )

  let imageWillSelect = spritesUtil.createImage(
    chessLayers.getLayers().abovePieces,
    sprites.chessCircle[0],
  )

  let imageSelected = spritesUtil.createImage(
    chessLayers.getLayers().abovePieces,
    sprites.chessSquare[0],
  )

  let imageHoveredTile = spritesUtil.createImage(
    chessLayers.getLayers().shadows,
    sprites.chessShadowBlack[0],
    //sprites.chessSquare[0],
  )
  imageHoveredTile.scale = 1
  imageHoveredTile.alpha = 0.5

  let imageShadow = spritesUtil.createImage(
    chessLayers.getLayers().shadows,
    sprites.chessShadowBlack[0],
  )
  imageShadow.scale = 1
  imageShadow.alpha = 0.25

  let textPiece = stevieTexts2.create(
    chessFonts.get().fBubble,
    0,
    0,
    chessLayers.getLayers().uiOnCam,
  )
  stevieTexts2.setScale(textPiece, 0.5)

  let obj: IChessPicker = {
    imageCursor,
    imageSelected,
    imageWillSelect,
    imageHoveredTile,
    selectedPiece: null,
    hoveredPiece: null,
    textPiece: textPiece,
    imageShadow,
    lastClosestPiece: null,
  }

  return obj
}

export function clearSelection() {
  setSelection(null)
}

export function setSelection(cr: IChessPiece | null) {
  let obj = get()
  obj.selectedPiece = cr
  // TODO: replaced with shader highlight
  obj.imageSelected.visible = false
  // if (cr) {
  //   obj.imageSelected.x = cr.x
  //   obj.imageSelected.y = cr.y
  //   obj.imageSelected.visible = true
  // } else {
  //   obj.imageSelected.visible = false
  // }
}

export function update() {
  let obj = get()
  // if (voyageGameManager.get().mode !== 'game') {
  //   obj.imageCursor.visible = false
  //   obj.imageSelected.visible = false
  //   obj.imageWillSelect.visible = false
  //   return
  // }
  obj.imageCursor.visible = false
  obj.imageSelected.visible = false
  obj.imageWillSelect.visible = false
  obj.imageHoveredTile.visible = false

  // Deselect dead stuff
  if (obj.selectedPiece && obj.selectedPiece.isDead) {
    setSelection(null)
  }
  if (obj.hoveredPiece && obj.hoveredPiece.isDead) {
    obj.hoveredPiece = null
  }
  let isGameStarted = chessGameMode_game.getIsGameStarted()

  let mou = chessCamera.getAdjustedMousePosition()

  let mij = chessTilemap.getIJAtMouse()
  let mxy = chessTilemap.convertIJtoXY(mij.i, mij.j)
  let tHere = chessTilemap.getSafe(mij.i, mij.j)

  chessPieces.moveExternalShadow2To(obj.imageHoveredTile, mxy)

  obj.imageCursor.x = mou.x
  obj.imageCursor.y = mou.y

  // if (obj.selectedCrew && obj.selectedCrew.isDead) {
  //   obj.selectedCrew = null
  // }

  obj.imageShadow.visible = false
  // if (obj.selectedPiece) {
  //   obj.imageSelected.x = obj.selectedPiece.x
  //   obj.imageSelected.y = obj.selectedPiece.y
  //   chessPieces.moveExternalShadowTo(obj.selectedPiece, obj.imageShadow)
  // } else {
  //   obj.imageShadow.visible = false
  // }

  let closestPiece: IChessPiece | null = null as IChessPiece | null
  let closestPieceDistance = 100

  let closestHoverPiece: IChessPiece | null = null as IChessPiece | null

  let team = chessGameManager.get().team // chessWebsockets.getIsHost() ? EChessTeam.White : EChessTeam.Black

  l.forEach(chessPieces.getAll(), (c) => {
    if (!chessPieces.readyToMove(c)) {
      return
    }

    if (c.team !== team) {
      return
    }

    let dist = distanceUtil.distanceNormalXY(mou, c)
    // console.log('dist', dist)
    if (dist < closestPieceDistance) {
      closestHoverPiece = c
      closestPieceDistance = dist
    }
  })

  obj.hoveredPiece = closestPiece || closestHoverPiece

  closestPiece = obj.hoveredPiece
  if (closestPiece) {
    chessPieces.setHighlighted(closestPiece, true)
  }
  if (obj.lastClosestPiece && obj.lastClosestPiece !== closestPiece) {
    chessPieces.setHighlighted(obj.lastClosestPiece, false)
  }
  obj.lastClosestPiece = closestPiece

  if (obj.hoveredPiece && !obj.selectedPiece) {
    stevieTexts2.setVisible(obj.textPiece, true)
    stevieTexts2.setText(obj.textPiece, obj.hoveredPiece.data.name)
    stevieTexts2.moveTo(
      obj.textPiece,
      obj.hoveredPiece.x - 32,
      obj.hoveredPiece.y + 32,
    )
  } else {
    stevieTexts2.setVisible(obj.textPiece, false)
  }

  // TODO: replaced with highlight
  obj.imageWillSelect.visible = false
  // if (closestPiece) {
  //   obj.imageWillSelect.visible = true
  //   obj.imageWillSelect.x = closestPiece.x
  //   obj.imageWillSelect.y = closestPiece.y
  // } else {
  //   obj.imageWillSelect.visible = false
  // }

  if (obj.selectedPiece) {
    // TODO: replaced with shader highlight
    // obj.imageSelected.visible = true
    // obj.imageSelected.x = obj.selectedPiece.x
    // obj.imageSelected.y = obj.selectedPiece.y

    chessPieces.moveToXY(obj.selectedPiece, mou.x, mou.y)

    // obj.imageSelected.tint = voyageColors.yellow
  } //else {
  //obj.imageSelected.visible = false
  //}

  if (isGameStarted) {
    if (clickEater.isLeftFirstDownAndUneaten()) {
      if (closestPiece) {
        if (chessPieces.readyToMove(closestPiece)) {
          setSelection(closestPiece)

          chessPieces.createDust(closestPiece)
          chessSounds.playPiecePickup()
          chessMessageCursorPick.sendMessageToOthers({
            command: EChessCursorPickCommand.Pickup,
            // multiId: chessWebsockets.getMultiId(),
            pieceId: closestPiece.id,
          })

          // voyageSounds.playSelected()
          clickEater.tempEat()
        }
      }
    }

    if (clickEater.isLeftFirstUpRegardless()) {
      if (obj.selectedPiece) {
        if (tHere) {
          let cm = chessTilemap.canMove(obj.selectedPiece, tHere)
          if (cm) {
            chessMessagePieceMoveRequest.sendMessageRequest({
              pieceId: obj.selectedPiece.id,
              i: tHere.i,
              j: tHere.j,
            })
          } else {
            chessPieces.moveToIJ(obj.selectedPiece, obj.selectedPiece, false)
            chessSounds.playCantMoveThere()
          }
        } else {
          // Move back to where it was
          chessPieces.moveToIJ(obj.selectedPiece, obj.selectedPiece, false)
          chessSounds.playCantMoveThere()
        }

        chessPieces.createDust(obj.selectedPiece)
        chessSounds.playPiecePutdown()
        chessMessageCursorPick.sendMessageToOthers({
          command: EChessCursorPickCommand.Putdown,
          // multiId: chessWebsockets.getMultiId(),
          pieceId: obj.selectedPiece.id,
        })

        setSelection(null)

        clickEater.tempEat()
      }
    }
  }
  if (!obj.selectedPiece) {
    obj.imageHoveredTile.visible = false
  }
  if (obj.selectedPiece) {
    obj.imageWillSelect.visible = false
  }
  chessTilemap.showCanMove(obj.selectedPiece)
}
